import authAPI from '@/api/auth';

const signIn = async (context, data) => {
  const response = await authAPI.signIn(data.credentials);
  if (response.status) {
    context.commit('setUser', response.data.user);
    context.commit('setTokenAuth', response.data.token);
    if (data.remind_me){
      window.localStorage.setItem('user', JSON.stringify(response.data.user));
      window.localStorage.setItem('auth_token', response.data.token);
    }
  }
  return response
}

let actions = {
  signIn
}

export default actions;
